import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Injector, Input, ViewChild } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { OverlayConfig } from '@angular/cdk/overlay';
import { TranslateService } from '@ngx-translate/core';
import { IInputComponent } from '@nimbus-library/features/shared/components/material/i-input-component';

@Component({
  standalone: false,
  selector: 'nimbus-input-tag-list',
  templateUrl: './input-tag-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputTagListComponent),
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: forwardRef(() => InputTagListComponent),
    },
  ],
})
export class InputTagListComponent extends IInputComponent<string[]> implements Validator {
  @Input()
  public options: string[] = [];
  @Input()
  public overlayPanelClass: string;

  public inputText: string;
  public filteredOptions: string[] = [];

  @ViewChild(MatAutocompleteTrigger)
  public set autocompleteTrigger(trigger: MatAutocompleteTrigger) {
    if (trigger && this.overlayPanelClass) {
      const originalConfigFn: () => OverlayConfig = (trigger as any)._getOverlayConfig;
      (trigger as any)._getOverlayConfig = (): OverlayConfig => {
        const config = originalConfigFn.call(trigger);
        const existing = Array.isArray(config.panelClass) ? config.panelClass : config.panelClass ? [config.panelClass] : [];
        config.panelClass = [...existing, this.overlayPanelClass];
        return config;
      };
    }
  }

  public constructor(changeDetectionRef: ChangeDetectorRef, injector: Injector, translateService: TranslateService) {
    super(changeDetectionRef, injector, translateService);
  }

  public onKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.code === 'Enter') {
      if (this.inputText) {
        this.addTag(this.inputText);
        this.inputText = '';
        this.filteredOptions = [];
      }
    }
  }

  public onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    this.addTag(event.option.value);
    this.inputText = '';
    this.filteredOptions = [];
  }

  public addTag(tagValue: string): void {
    this.value = [...(this.value || []), tagValue];
    this.inputText = null;
  }

  public onSearchInputChange(value: string): void {
    const filterValue = value.toLowerCase();
    const options = (this.options || []).filter((option) => !this.value.includes(option));
    this.filteredOptions = !!value ? options.filter((option) => option.toLowerCase().includes(filterValue)) : options;
  }

  public writeValue(value: string[]): void {
    this.inputText = '';
    super.writeValue(value);
  }

  public validate(control: AbstractControl): ValidationErrors {
    let result: ValidationErrors;
    if (control && control.value && control.value.length && new Set(control.value).size !== control.value.length) {
      result = { unique: false };
    } else {
      result = null;
    }
    return result;
  }
}
